export const AUTH_ERRORS_CODES = {
  InvalidCredentials: 41002
} as const
